import React, { useContext } from "react";
import clsx from "clsx";
import PropTypes from "prop-types";
import { Link } from "gatsby";
import useTranslations from "../../hoc/useTranslations";
import { LocaleContext } from "../../components/Layout/Layout";
import Form from "../../components/Form/Form";
import Heading from "../../components/Heading/Heading";
import LinkedinButton from "../../components/LinkedinButton/LinkedinButton";
import { routes } from "../../routes";

import PaperPlaneSVG from "../../assets/icons/paper_plane.svg";

import "./Footer.scss";

const Footer = ({ isPolish }) => {
	const { locale, forPage } = useContext(LocaleContext);

	const {
		footer: { title, menus },
	} = useTranslations();

	const footerMenusLinks = [
		["tel:+48601789982", isPolish ? "mailto:kontakt@botwise.io" : "mailto:contact@botwise.io"],
		[
			routes[locale].blog,
			`${routes[locale].blog}/tag/case-study`,
			routes[locale].customerCareLP,
			routes[locale].privacyPolicy,
			routes[locale].privacyPolicy,
		],
	];

	const displayLink = (menuIndex, { text, link }) => {
		if (!link) return null;

		switch (menuIndex) {
			case 1:
				return <Link to={link}>{text}</Link>;
			default:
				return <a href={link}>{text}</a>;
		}
	};

	return (
		<footer className={clsx("footer", forPage === "customer_care" && "footer__custom")}>
			{forPage !== "customer_care" && (
				<>
					<Heading type={2} className="footer__heading">
						{title}
						<PaperPlaneSVG className="footer__heading--icon" />
					</Heading>
					<Form lighten />
				</>
			)}
			<div className="footer__bottom">
				<nav className="footer__navigation">
					{menus.map(({ menu_title, items }, menuIndex) => (
						<ul key={menu_title} className="footer__navigation--container">
							<p className="footer__navigation--title">{menu_title}</p>
							{items.map(({ text }, itemIndex) => (
								<li key={text} className="footer__navigation--item">
									{displayLink(menuIndex, {
										text,
										link: footerMenusLinks[menuIndex][itemIndex],
									})}
								</li>
							))}
						</ul>
					))}
				</nav>
				<div className="footer__company">
					<p className="footer__company--text">BOTWISE.io Sp. z o.o.</p>
					<p className="footer__company--text">NIP: 8952216674</p>
					<p className="footer__company--text">KRS: 0000834558</p>
					<p className="footer__company--text">REGON: 38582208600000</p>
				</div>
			</div>
			<div className="footer__rights">
				<LinkedinButton />
				<span className="footer__rights--text">
					All rights reserved. &copy; BOTWISE {new Date().getFullYear()}
				</span>
			</div>
		</footer>
	);
};

Footer.propTypes = {
	isPolish: PropTypes.bool.isRequired,
};

export default Footer;
